import { colors } from '@styles/global/colors'
import { ITheme } from '@styles/themes/darkTheme'

const darkSlate = `#545659`
const highlight1 = `#65807c`
const highlight2 = `#4a5a59`
const DefaultTheme: ITheme = {
  type: 'default',
  textColor: '#333F4F',
  subheaderColor: colors.grey.i600,
  headlineColor: darkSlate,
  backgroundPrimary: `#f7f7f6`,
  backgroundSecondary: `#ffffff`,
  lineColor: `#e1e4e9`,
  logoColor: `#333F4F`,
  linkColor: '#007bff',
  linkHoverColor: colors.blue.i600,
  highlight: {
    i500: highlight1,
  },
  outline: `#3F4B5B`,
  buttonPrimary: {
    backgroundColor: `#fff`,
    backgroundHoverColor: highlight2,
    textColor: highlight1,
    textHoverColor: `#fff`,
  },
  shadows: {
    i800: {
      hover: `0px 40px 50px rgba(0, 0, 0, 0.5)`,
      init: `0px 40px 50px rgba(0, 0, 0, 0)`,
    },
  },
  nav: {
    openColor: '#fff',
    color: colors.purple.i500,
    textColor: colors.primary.text,
  },

}

export default DefaultTheme
